import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import RouteInternal from './routeInternal';
import RouteExternal from './routeExternal';
import Login from '../../pages/Login';
import Dashboard from '../../pages/Dashboard';
import BarksdaleAdminDashboard from '../../pages/Dashboard/barksdaleAdminDashboard';
// import AnalyticsPage from '../../pages/Analytics';
import MultipleExtranet from '../../pages/Login/multipleExtranet';
import AdminUser from '../../pages/Admin';
import AdminUserDelete from '../../pages/Admin/user/deleteUser';
import AdminUserEdit from '../../pages/Admin/user/editUser';
import AdminUserAdd from '../../pages/Admin/user/addUser';
import AdminTempPasswordCreate from '../../pages/Admin/tempPassword/create';
import AdminTempPasswordDisplay from '../../pages/Admin/tempPassword/display';
import AdminVerifyUser from '../../pages/Admin/verifyUser';
import AdminManageOrder from '../../pages/Admin/manageOrder';
import OnBehalfUsersManagement from '../../pages/Admin/onBehalfUsers';
import ForgotPassword from '../../pages/PasswordRecovery/forgot-password';
import ResetPassword from '../../pages/PasswordRecovery/reset-password';
import ChangePassword from '../../pages/Profile/change-password';
import EditProfile from '../../pages/Profile/edit-profile';
import ChangeTempPassword from '../../pages/PasswordRecovery/change-temp-password';
import Resources from '../../pages/Resources';
import ResourceDetails from '../../pages/Resources/resource-details';
import ProductHighlights from '../../pages/Resources/category-pages/product-highlights';
import S5ProductTraining from '../../pages/Resources/category-pages/s5-product-training';
import TechnicalRequest from '../../pages/Resources/category-pages/technical-request';
import NewSalesTools from '../../pages/NewSalesTools';
import CategoryPage from '../../pages/NewSalesTools/CategoryPage';
import SalesToolDetail from '../../pages/NewSalesTools/SalesToolDetail';
import Inventory from '../../pages/Inventory';
import InventorySearch from '../../pages/Inventory/search-inventory';
import InventoryDetails from '../../pages/Inventory/inventory-details';
import InventoryUpload from '../../pages/Inventory/upload-inventory';
import LeadTime from '../../pages/Inventory/leadtime';
import LeadTimeSearchResult from '../../pages/Inventory/leadtime/search-result';
import OtherExtranet from '../../pages/OtherExtranet';
import LeadTimeSearchResultWhoHasIt from '../../pages/Inventory/leadtime/search-result-who-has-it';
import OEManageCP from '../../pages/OtherExtranet/manageCP';
import OEManageCPUserList from '../../pages/OtherExtranet/manageCP/userList';
import OEChannelPartnersDetails from '../../pages/OtherExtranet/manageCP/channelPartnersDetails';
import OEChannelPartnetsAddUser from '../../pages/OtherExtranet/manageCP/channelPartnerAddUser';
import OEManageCPUploadDate from '../../pages/OtherExtranet/manageCP/uploadDate';
import OEChannelPartnerDeleteUser from '../../pages/OtherExtranet/manageCP/channelPartnerDeleteUser';
import OEChannelPartnerEditUser from '../../pages/OtherExtranet/manageCP/channelPartnerEditUser';
import OEDeleteUserFromUserList from '../../pages/OtherExtranet/manageCP/userListDeleteUser';
import OEUpdateUserFromUserList from '../../pages/OtherExtranet/manageCP/userListUpdateUser';
import SignUpInitiate from '../../pages/SignUp/initiate';
import SignUpValidate from '../../pages/SignUp/validate';
import OrderManagementSystem from '../../pages/OrderManagementSystem';
import OnlineOrderEntry from '../../pages/OrderManagementSystem/online-order-entry';
import CheckOrderStatus from '../../pages/OrderManagementSystem/check-order-status';
import InventorySearchResult from '../../pages/Inventory/search-inventory-result';
import CheckOrderStatusOrderDetails from '../../pages/OrderManagementSystem/check-order-status-order-details';
import CheckOrderStatusCustomerOrderDetails from '../../pages/OrderManagementSystem/check-order-status-customer-order-details';
import CheckOrderStatusItemDetails from '../../pages/OrderManagementSystem/check-order-status-item-details';
import CheckOrderStatusMultipleResults from '../../pages/OrderManagementSystem/check-order-status-multiple-results';
import OnlineOrderEntryHeader from '../../pages/OrderManagementSystem/online-order-entry-header';
import OnlineOrderEntryOrder from '../../pages/OrderManagementSystem/online-order-entry-order';
import OnlineOrderEntryOrderSend from '../../pages/OrderManagementSystem/online-order-entry-order-send';
import OnlineOrderEntryOrderSendConfirm from '../../pages/OrderManagementSystem/online-order-entry-order-send-confirm';
import OnlineOrderEntryAddProduct from '../../pages/OrderManagementSystem/online-order-entry-add-product';
import OnlineOrderEntryOrderCancel from '../../pages/OrderManagementSystem/online-order-entry-order-cancel';
import OnlineOrderEntryOrderCancelConfirm from '../../pages/OrderManagementSystem/online-order-entry-order-cancel-confirm';
import OnlineOrderEntryAddProductSetPoint from '../../pages/OrderManagementSystem/online-order-entry-add-product-set-point';
import CheckPurchaseOrderStatusDetails from '../../pages/OrderManagementSystem/check-po-order-status-details';

const Router = () => {

  const renderInternalRoute = (Component, requiredPermission = null, requiredDetailedPermission = null) => {
    return (
      <RouteInternal requiredPermission={requiredPermission} requiredDetailedPermission={requiredDetailedPermission}>
        {Component}
      </RouteInternal>
    );
  }
  const renderExternalRoute = (Component) => {
    return (
      <RouteExternal>
        {Component}
      </RouteExternal>
    );
  }
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={ renderExternalRoute(<Login />) } />
        <Route path="/forgot-password" element={ renderExternalRoute(<ForgotPassword />) } />
        <Route path="/reset-password" element={ renderExternalRoute(<ResetPassword />) } />
        {/* <Route path="/change-temp-password" element={ renderInternalRoute(<ChangeTempPassword />) } /> */}
        <Route path="/change-temp-password" element={ <ChangeTempPassword /> } />
        <Route path="/multiple-extranet" element={ renderInternalRoute(<MultipleExtranet />) }/>
        <Route path="/signup" element={renderExternalRoute(<Outlet />)}>
          <Route path="initiate" element={ renderExternalRoute(<SignUpInitiate />) } />
          <Route path="validate" element={ renderExternalRoute(<SignUpValidate />) } />
        </Route>
        
        <Route path="*" element={<Navigate to="/login" replace />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={ renderInternalRoute(<Dashboard />) }/>
        {/* <Route path="/analytics" element={ renderInternalRoute(<AnalyticsPage />) }/> */}
        <Route path="/barksdale-admin" element={ renderInternalRoute(<BarksdaleAdminDashboard />) }/>

        <Route path="/inventory" element={renderInternalRoute(<Outlet />, 'inventory')}>
          <Route index element={renderInternalRoute(<Inventory />, 'inventory')} />
          <Route path="search" element={renderInternalRoute(<InventorySearch />, 'inventory')} />
          {/* <Route path="upload" element={renderInternalRoute(<InventoryUpload />, 'inventory', 'inventory.uploadInventory')} /> */}
          <Route path="details/:repName/:partNo" element={renderInternalRoute(<InventoryDetails />, 'inventory')} />
          <Route path="lead-time" element={renderInternalRoute(<LeadTime />, 'inventory')} />
          <Route path="lead-time/search-result" element={renderInternalRoute(<LeadTimeSearchResult />, 'inventory')} />
          <Route path="lead-time/search-result-who-has-it" element={renderInternalRoute(<LeadTimeSearchResultWhoHasIt />, 'inventory')} />
          <Route path="inventory-search-result" element={renderInternalRoute(<InventorySearchResult />, 'inventory')} />
        </Route>

        <Route path="/otherextranet" element={renderInternalRoute(<Outlet />, 'otherExtranet')}>
          <Route index element={renderInternalRoute(<OtherExtranet />, 'otherExtranet')} />
          <Route path="managecp" element={renderInternalRoute(<OEManageCP />, 'otherExtranet')} />
          <Route path="managecp/user-list/:role" element={renderInternalRoute(<OEManageCPUserList />, 'otherExtranet')} />
          <Route path="managecp/cp-details/:id" element={renderInternalRoute(<OEChannelPartnersDetails />, 'otherExtranet')} />
          <Route path="managecp/add-user" element={renderInternalRoute(<OEChannelPartnetsAddUser />, 'otherExtranet')} />
          <Route path="managecp/upload-date" element={renderInternalRoute(<OEManageCPUploadDate />, 'otherExtranet')} />
          <Route path="managecp/delete-user/:id" element={renderInternalRoute(<OEChannelPartnerDeleteUser />, 'otherExtranet')} />
          <Route path="managecp/edit-user/:id" element={renderInternalRoute(<OEChannelPartnerEditUser />, 'otherExtranet')} />
          <Route path="managecp/delete-user-userlist/:id" element={renderInternalRoute(<OEDeleteUserFromUserList />, 'otherExtranet')} />
          <Route path="managecp/update-user-userlist/:id" element={renderInternalRoute(<OEUpdateUserFromUserList />, 'otherExtranet')} />
        </Route>
        
        <Route path="/admin" element={renderInternalRoute(<Outlet />, 'admin')}>
          <Route index element={renderInternalRoute(<AdminUser />, 'admin')} />
          <Route path="user/add" element={renderInternalRoute(<AdminUserAdd />, 'admin')} />
          <Route path="user/edit/:userId" element={renderInternalRoute(<AdminUserEdit />, 'admin')} />
          <Route path="user/delete/:userId" element={renderInternalRoute(<AdminUserDelete />, 'admin')} />
          <Route path="temp-password/create" element={renderInternalRoute(<AdminTempPasswordCreate />, 'admin')} />
          <Route path="temp-password/display" element={renderInternalRoute(<AdminTempPasswordDisplay />, 'admin')} />
          <Route path="verify-user" element={renderInternalRoute(<AdminVerifyUser />, 'admin')} />
          <Route path="manage-order" element={renderInternalRoute(<AdminManageOrder />, 'admin')} />
          <Route path="on-behalf-users" element={renderInternalRoute(<OnBehalfUsersManagement />, 'admin')} />
        </Route>
        
        <Route path="/resources" element={renderInternalRoute(<Outlet />, 'resources')}>
          <Route index element={renderInternalRoute(<NewSalesTools />, 'resources')} />
          <Route path="category/:categoryId" element={renderInternalRoute(<CategoryPage />, 'resources')} />
          <Route path="category/:categoryId/:subcategoryId" element={renderInternalRoute(<CategoryPage />, 'resources')} />
          <Route path="detail/:itemId" element={renderInternalRoute(<SalesToolDetail />, 'resources')} />
          <Route path="resource-details/:itemId" element={renderInternalRoute(<ResourceDetails />, 'resources')} />
          <Route path="product-highlights" element={renderInternalRoute(<ProductHighlights />, 'resources')} />
          <Route path="s5-product-training" element={renderInternalRoute(<S5ProductTraining />, 'resources')} />
          <Route path="technical-request" element={renderInternalRoute(<TechnicalRequest />, 'resources')} />
        </Route>

        <Route path="/order-management-system" element={renderInternalRoute(<Outlet />, 'oms')}>
          <Route index element={renderInternalRoute(<OrderManagementSystem />, 'oms')} />

          <Route path="check-order-status" element={renderInternalRoute(<Outlet />, 'oms', 'oms.checkOrderStatus')}>
            <Route index element={renderInternalRoute(<CheckOrderStatus />, 'oms', 'oms.checkOrderStatus')} />
            <Route path="order/:orderNumber" element={renderInternalRoute(<CheckOrderStatusOrderDetails />, 'oms', 'oms.checkOrderStatus')} />
            <Route path="purchase/:poNumber" element={renderInternalRoute(<CheckPurchaseOrderStatusDetails />, 'oms', 'oms.checkOrderStatus')} />
            <Route path="so/:orderNumber" element={renderInternalRoute(<CheckOrderStatusMultipleResults />, 'oms', 'oms.checkOrderStatus')} />
            <Route path="po/:orderNumber" element={renderInternalRoute(<CheckOrderStatusMultipleResults />, 'oms', 'oms.checkOrderStatus')} />
            <Route path="customer/:orderNumber" element={renderInternalRoute(<CheckOrderStatusCustomerOrderDetails />, 'oms', 'oms.checkOrderStatus')} />
            <Route path="item/:orderNumber" element={renderInternalRoute(<CheckOrderStatusItemDetails />, 'oms', 'oms.checkOrderStatus')} />
          </Route>
          
          <Route path="online-order-entry" element={renderInternalRoute(<Outlet />, 'oms', 'oms.onlineOrderEntry')}>
            <Route index element={renderInternalRoute(<OnlineOrderEntry />, 'oms', 'oms.onlineOrderEntry')} />
            <Route path="header" element={renderInternalRoute(<OnlineOrderEntryHeader />, 'oms', 'oms.onlineOrderEntry')} />
            <Route path="order" element={renderInternalRoute(<OnlineOrderEntryOrder />, 'oms', 'oms.onlineOrderEntry')} />
            <Route path="order/send" element={renderInternalRoute(<OnlineOrderEntryOrderSend />, 'oms', 'oms.onlineOrderEntry')} />
            <Route path="order/send-confirm" element={renderInternalRoute(<OnlineOrderEntryOrderSendConfirm />, 'oms', 'oms.onlineOrderEntry')} />
            <Route path="order/cancel" element={renderInternalRoute(<OnlineOrderEntryOrderCancel />, 'oms', 'oms.onlineOrderEntry')} />
            <Route path="order/cancel-confirm" element={renderInternalRoute(<OnlineOrderEntryOrderCancelConfirm />, 'oms', 'oms.onlineOrderEntry')} />
            <Route path="add-product/:productNumber/:productQuantity" element={renderInternalRoute(<OnlineOrderEntryAddProduct />, 'oms', 'oms.onlineOrderEntry')} />
            <Route path="add-product/set-point/:productNumber/:productQuantity" element={renderInternalRoute(<OnlineOrderEntryAddProductSetPoint />, 'oms', 'oms.onlineOrderEntry')} />
          </Route>
        </Route>

        <Route path="/profile/edit" element={ renderInternalRoute(<EditProfile />) } />
        <Route path="/change-password" element={ renderInternalRoute(<ChangePassword />) } />

        <Route path="/upload" element={renderInternalRoute(<InventoryUpload />, 'uploadInventory')} />

      </Routes>
    </BrowserRouter>
  );
}

export default Router;
